import type { RouteObject } from 'react-router-dom'
import type { DashboardWidget, FrontendModule } from '@/lib/types'

import casesModule from './cases'
import documentsModule from './documents'
import deadlinesModule from './deadlines'
import tasksModule from './tasks'
import timesheetModule from './timesheet'
import adminModule from './admin'

/**
 * Rejestr modułów frontendu (CONTRACTS.md §7).
 * Lista jest statyczna — o widoczności decyduje `/api/me/context`
 * (moduł wyłączony w env lub niewidoczny dla roli po prostu nie przyjdzie).
 */
export const MODULES: FrontendModule[] = [
  casesModule,
  documentsModule,
  deadlinesModule,
  tasksModule,
  timesheetModule,
  adminModule,
]

/** Moduły dostępne dla zalogowanego użytkownika. */
export function enabledModules(moduleKeys: string[]): FrontendModule[] {
  const allowed = new Set(moduleKeys)
  return MODULES.filter((module) => allowed.has(module.key))
}

/**
 * Trasy modułów gotowe dla `useRoutes` osadzonego w powłoce aplikacji.
 * Ścieżki najwyższego poziomu podane jako absolutne („/sprawy") są
 * normalizowane do względnych — obie konwencje w modułach są poprawne.
 */
export function moduleRoutes(moduleKeys: string[]): RouteObject[] {
  return enabledModules(moduleKeys).flatMap((module) => module.routes.map(normalizeRoute))
}

function normalizeRoute(route: RouteObject): RouteObject {
  if ('index' in route && route.index) return route
  if (typeof route.path === 'string' && route.path.startsWith('/')) {
    return { ...route, path: route.path.replace(/^\/+/, '') }
  }
  return route
}

/** Widgety pulpitu zadeklarowane przez moduły, posortowane wg `order`. */
export function dashboardWidgets(moduleKeys: string[], column: DashboardWidget['column']): DashboardWidget[] {
  return enabledModules(moduleKeys)
    .flatMap((module) => module.dashboardWidgets ?? [])
    .filter((widget) => widget.column === column)
    .sort((a, b) => (a.order ?? 100) - (b.order ?? 100))
}
